export enum REQUEST_STATUS {
    PENDING = 'pending',
    NOT_INITIALISED = 'not-initialised',
    FULFILLED = 'fulfilled',
    REJECTED = 'rejected',
}
